import React, { FunctionComponent } from "react";
import { useTranslation } from "react-i18next";

import { useOnLanguageChange } from "@/hooks/Translations";

interface IPublicAnchorProps {
  page: string;
  className?: string;
  target?: string;
}

export const PublicAnchor: FunctionComponent<IPublicAnchorProps> = ({
  page,
  className,
  target = "_self",
  children,
}) => {
  const lang = useOnLanguageChange();
  const { t } = useTranslation("public");

  const link = page ? t(`LINKS.${page}`) : page;
  const baseUrl =
    window.__MAIN_PAGE_URL__ && window.__MAIN_PAGE_URL__ !== "<MAIN_PAGE_URL>"
      ? window.__MAIN_PAGE_URL__
      : "https://www.test.verama.com";

  return (
    <a
      href={`${baseUrl}/${lang}/${link}`}
      target={target}
      className={className}
      {...(target === "_blank" && { rel: "noopener noreferrer" })}>
      {children}
    </a>
  );
};
